import { render, staticRenderFns } from "./PositionMappingApprove.vue?vue&type=template&id=600bd6df&scoped=true&"
import script from "./PositionMappingApprove.vue?vue&type=script&lang=js&"
export * from "./PositionMappingApprove.vue?vue&type=script&lang=js&"
import style0 from "./PositionMappingApprove.vue?vue&type=style&index=0&id=600bd6df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600bd6df",
  null
  
)

export default component.exports